"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.personUsualSchoolPlaceGeography = exports.personUsualWorkPlaceGeography = exports.personSchoolType = exports.householdMembers = void 0;
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelperNew = __importStar(require("evolution-common/lib/utils/helpers"));
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const activityIconMapping_1 = require("evolution-common/lib/services/questionnaire/sections/visitedPlaces/activityIconMapping");
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const defaultInputBase = __importStar(require("evolution-frontend/lib/components/inputs/defaultInputBase"));
const conditionals = __importStar(require("../../common/conditionals"));
const widgetsNames_1 = require("./widgetsNames");
const customConditionals = __importStar(require("../../common/customConditionals"));
const choices = __importStar(require("../../common/choices"));
const customValidations_1 = require("../../common/customValidations");
// TODO: Migrate most of these widgets in Evolution Frontend, not here.
exports.householdMembers = {
    type: 'group',
    path: 'household.persons',
    title: {
        fr: 'Membres du ménage',
        en: 'Household members'
    },
    name: {
        fr: function (groupedObject, sequence, interview) {
            const householdSize = surveyHelperNew.getResponse(interview, 'household.size', 1);
            if (householdSize === 1) {
                return 'Veuillez entrer les informations suivantes:';
            }
            return `Personne ${sequence || groupedObject['_sequence']} ${groupedObject.nickname ? `• **${groupedObject.nickname}**` : ''}`;
        },
        en: function (groupedObject, sequence, interview) {
            const householdSize = surveyHelperNew.getResponse(interview, 'household.size', 1);
            if (householdSize === 1) {
                return 'Please enter the following information:';
            }
            return `Person ${sequence || groupedObject['_sequence']} ${groupedObject.nickname ? `• **${groupedObject.nickname}**` : ''}`;
        }
    },
    showGroupedObjectDeleteButton: function (interview, path) {
        const countPersons = odSurveyHelpers.countPersons({ interview });
        const householdSize = surveyHelperNew.getResponse(interview, 'household.size', null);
        const householdSizeNum = householdSize ? Number(householdSize) : undefined;
        return householdSizeNum ? countPersons > householdSizeNum : false;
    },
    showGroupedObjectAddButton: function (interview, path) {
        return true;
    },
    groupedObjectAddButtonLabel: (t) => t('household:addGroupedObject'),
    groupedObjectDeleteButtonLabel: (t) => t('household:deleteThisGroupedObject'),
    addButtonSize: 'small',
    widgets: widgetsNames_1.householdMembersWidgetsNames
};
exports.personSchoolType = Object.assign(Object.assign({}, defaultInputBase.inputRadioBase), { path: 'schoolType', twoColumns: false, containsHtml: true, customPath: 'schoolTypeOther', customChoice: 'other', label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        // Different label based on age
        if ((activePerson === null || activePerson === void 0 ? void 0 : activePerson.age) < 4) {
            // For children under 4
            return t('household:schoolTypeLessThan4');
        }
        else if ((activePerson === null || activePerson === void 0 ? void 0 : activePerson.age) <= 15) {
            // For children between 4 and 15
            return t('household:schoolTypeBetween4And15');
        }
        else {
            // For people over 15
            return t('household:schoolType');
        }
    }, choices: choices.schoolType, conditional: conditionals.ifAge15OrLessConditional, validations: validations.requiredValidation });
exports.personUsualWorkPlaceGeography = {
    type: 'question',
    inputType: 'mapFindPlace',
    path: 'usualWorkPlace.geography',
    datatype: 'geojson',
    containsHtml: true,
    height: '32rem',
    refreshGeocodingLabel: (t) => t('customLabel:RefreshGeocodingLabel'),
    geocodingQueryString: function (interview, path) {
        return surveyHelperNew.formatGeocodingQueryStringFromMultipleFields([
            surveyHelperNew.getResponse(interview, path, null, '../name')
        ]);
    },
    label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        const countPersons = odSurveyHelpers.countPersons({ interview });
        const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
        return t('household:usualWorkPlace.geography', {
            nickname,
            count: countPersons
        });
    },
    icon: {
        url: (0, activityIconMapping_1.getActivityMarkerIcon)('workUsual'),
        size: [70, 70]
    },
    placesIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle.svg',
        size: [35, 35]
    },
    selectedIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle_selected.svg',
        size: [35, 35]
    },
    defaultCenter: function (interview, path) {
        const homeCoordinates = surveyHelperNew.getResponse(interview, 'home.geography.geometry.coordinates', null);
        return homeCoordinates
            ? {
                lat: homeCoordinates[1],
                lon: homeCoordinates[0]
            }
            : project_config_1.default.mapDefaultCenter;
    },
    defaultValue: function (interview, path) {
        return undefined;
    },
    updateDefaultValueWhenResponded: true,
    validations: function (value, _customValue, interview, path, _customPath) {
        const geography = surveyHelperNew.getResponse(interview, path, null, '../geography');
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('survey:visitedPlace:locationIsRequiredError')
            },
            {
                validation: geography &&
                    geography.properties.lastAction &&
                    (geography.properties.lastAction === 'mapClicked' ||
                        geography.properties.lastAction === 'markerDragged') &&
                    geography.properties.zoom < 15,
                errorMessage: {
                    fr: 'Le positionnement du lieu n\'est pas assez précis. Utilisez le zoom + pour vous rapprocher davantage, puis précisez la localisation en déplaçant l\'icône.',
                    en: 'Location is not precise enough. Please use the + zoom and drag the icon marker to confirm the precise location.'
                }
            },
            ...(0, customValidations_1.inaccessibleZoneGeographyCustomValidation)(geography, undefined, interview, path)
        ];
    },
    conditional: conditionals.hasWorkingLocationConditional
};
exports.personUsualSchoolPlaceGeography = {
    type: 'question',
    inputType: 'mapFindPlace',
    path: 'usualSchoolPlace.geography',
    datatype: 'geojson',
    containsHtml: true,
    height: '32rem',
    refreshGeocodingLabel: (t) => t('customLabel:RefreshGeocodingLabel'),
    geocodingQueryString: function (interview, path) {
        return surveyHelperNew.formatGeocodingQueryStringFromMultipleFields([
            surveyHelperNew.getResponse(interview, path, null, '../name')
        ]);
    },
    label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        const countPersons = odSurveyHelpers.countPersons({ interview });
        const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
        return t('household:usualSchoolPlace.geography', {
            nickname,
            count: countPersons
        });
    },
    icon: {
        url: (0, activityIconMapping_1.getActivityMarkerIcon)('schoolUsual'),
        size: [70, 70]
    },
    placesIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle.svg',
        size: [35, 35]
    },
    selectedIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle_selected.svg',
        size: [35, 35]
    },
    defaultCenter: function (interview, path) {
        const homeCoordinates = surveyHelperNew.getResponse(interview, 'home.geography.geometry.coordinates', null);
        return homeCoordinates
            ? {
                lat: homeCoordinates[1],
                lon: homeCoordinates[0]
            }
            : project_config_1.default.mapDefaultCenter;
    },
    defaultValue: function (interview, path) {
        return undefined;
    },
    updateDefaultValueWhenResponded: true,
    validations: function (value, _customValue, interview, path, _customPath) {
        const geography = surveyHelperNew.getResponse(interview, path, null, '../geography');
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('survey:visitedPlace:locationIsRequiredError')
            },
            {
                validation: geography &&
                    geography.properties.lastAction &&
                    (geography.properties.lastAction === 'mapClicked' ||
                        geography.properties.lastAction === 'markerDragged') &&
                    geography.properties.zoom < 15,
                errorMessage: {
                    fr: 'Le positionnement du lieu n\'est pas assez précis. Utilisez le zoom + pour vous rapprocher davantage, puis précisez la localisation en déplaçant l\'icône.',
                    en: 'Location is not precise enough. Please use the + zoom and drag the icon marker to confirm the precise location.'
                }
            },
            ...(0, customValidations_1.inaccessibleZoneGeographyCustomValidation)(geography, undefined, interview, path)
        ];
    },
    conditional: customConditionals.personUsualSchoolPlaceNameCustomConditional
};
